const testimonials = [
  {
    name: "J P",
    review:
      "Other companies required major construction for 4x the cost. CLWizard came in, treated the source, and the leak was gone. Worth every dollar.",
    stars: 5,
    via: "Google Review",
  },
  {
    name: "Flying Arrow Productions",
    review:
      "Every company had a different explanation. None of them fixed it. CL Wizard are the only ones who actually fixed it — permanently.",
    stars: 5,
    via: "Google Review",
  },
  {
    name: "Joshua Mendel",
    review:
      "The only company to provide a lasting solution. We had tried everything. CLWizard treated the concrete from within and the problem has not returned.",
    stars: 5,
    via: "Google Review",
  },
];

const badges = [
  { icon: "ri-medal-fill", label: "Engineer-Approved" },
  { icon: "ri-file-shield-2-fill", label: "Insurance Consultant Accepted" },
  { icon: "ri-shield-star-fill", label: "5-Year Written Warranty" },
];

export default function TrustSection() {
  return (
    <section id="trust" className="bg-[#0a0e1a] py-20 md:py-28">
      <div className="max-w-6xl mx-auto px-4 md:px-8">

        {/* Headline */}
        <div className="text-center mb-12">
          <p className="text-[#4a7fa5] font-bold uppercase tracking-widest text-sm mb-3">Standards &amp; Credentials</p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-white max-w-3xl mx-auto leading-tight">
            Engineered for the Most{" "}
            <span className="text-[#4a7fa5]">Demanding Standards</span>
          </h2>
        </div>

        {/* Badges row */}
        <div className="flex flex-wrap justify-center gap-3 md:gap-4 mb-12">
          {badges.map((b) => (
            <div
              key={b.label}
              className="flex items-center gap-2 md:gap-3 bg-[#0f1525] border border-[#1a3a5c]/50 rounded-full px-4 md:px-6 py-2.5 md:py-3"
            >
              <span className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center">
                <i className={`${b.icon} text-[#4a7fa5] text-base md:text-lg`}></i>
              </span>
              <span className="text-white font-semibold text-xs md:text-sm">{b.label}</span>
            </div>
          ))}
        </div>

        {/* Warranty seal + testimonials */}
        <div className="flex flex-col lg:grid lg:grid-cols-4 gap-8 items-start">

          {/* Warranty seal */}
          <div className="lg:col-span-1 flex flex-col items-center text-center mx-auto">
            <div className="w-36 h-36 md:w-44 md:h-44 flex items-center justify-center">
              <img
                src="https://clwizard.com/wp-content/uploads/2025/04/Selo_Garantia_Product_and_Service.png"
                alt="5-Year Warranty Seal"
                className="w-full h-full object-contain"
              />
            </div>
            <p className="text-gray-400 text-xs mt-3 leading-relaxed max-w-[160px]">
              Every project backed by a written 5-year warranty
            </p>
          </div>

          {/* Testimonials */}
          <div className="lg:col-span-3 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
            {testimonials.map((t) => (
              <div
                key={t.name}
                className="bg-[#0f1525] border border-white/10 rounded-lg p-5 md:p-6 flex flex-col gap-4 hover:border-[#1a3a5c]/60 transition-colors"
              >
                {/* Stars */}
                <div className="flex items-center gap-0.5">
                  {Array.from({ length: t.stars }).map((_, i) => (
                    <span key={i} className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-star-fill text-yellow-400 text-sm"></i>
                    </span>
                  ))}
                </div>

                {/* Quote */}
                <p className="text-gray-300 text-sm leading-relaxed flex-1">
                  &ldquo;{t.review}&rdquo;
                </p>

                {/* Author */}
                <div className="border-t border-white/10 pt-4 flex items-center justify-between">
                  <div>
                    <p className="text-white font-bold text-sm">{t.name}</p>
                    <p className="text-gray-500 text-xs">{t.via}</p>
                  </div>
                  <div className="w-7 h-7 flex items-center justify-center">
                    <i className="ri-google-fill text-gray-500 text-lg"></i>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
